import { render, staticRenderFns } from "./HeaderMenuItem.vue?vue&type=template&id=1ae31a83&scoped=true&"
import script from "./HeaderMenuItem.vue?vue&type=script&lang=js&"
export * from "./HeaderMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./HeaderMenuItem.vue?vue&type=style&index=0&id=1ae31a83&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae31a83",
  null
  
)

export default component.exports